<template>
    <div>

        <b-modal size="xl" ref="modalSelect" hide-footer title="Choice Product">


            <div class="form-group">

                <label>Filter</label>

                <div class="input-group ">
                    <input v-model="keyword" type="text" class="form-control input-search"
                           placeholder="Product Name, Tag or SKU" @keyup.enter="fetch">
                    <div class="input-group-append">
                        <button class="btn btn-outline-secondary" type="button" @click="fetch">
                            <i class="fi-search"/>
                        </button>
                    </div>
                </div>
            </div>
            <label>Select Product:</label>
            <div class="row">
                <table class="table table-hover">
                    <tr v-for="product in products" :key="product.id" scope="row">
                        <td width="112" class="position-relative"
                            @mouseover="showImg(product, true)"
                            @mouseleave="showImg(product, false)">
                            <img class="thumb-lg" :src="product.thumb" alt="">

                            <image-big
                                    :id="product.id"
                                    :img="product.thumb"
                                    :show="product.showImg"
                            />
                        </td>
                        <td><h5 class="mb-2">{{ product.name }}</h5> <span
                                class="text-muted">SKU: {{ product.sku }}</span></td>
                        <td>
                            <multiselect placeholder="Style" v-model="product_style"
                                         :options="getStyle(product.style)"></multiselect>

                        </td>
                        <td>
                            <multiselect placeholder="Template" v-model="product_template"
                                         :options="templateOptions"
                                         track-by="id" label="name"></multiselect>

                        </td>
                        <td class="align-content-between">
                            <button @click="selectProduct(product)" class="btn btn-block btn-success">Select
                            </button>
                        </td>
                    </tr>
                </table>

            </div>


            <div class="d-flex">
                <div class="btn-group btn-group-sm mt-2" role="group" aria-label="paging">
                    <button :disabled="page <= 1" type="button" class="btn btn-outline-secondary"
                            @click="prevPage">
                        <i class="dripicons-chevron-left"/>
                    </button>
                    <button :disabled="products.more == false" type="button" class="btn btn-outline-secondary"
                            @click="nextPage">
                        <i class="dripicons-chevron-right"/>
                    </button>
                </div>
            </div>


        </b-modal>
        <div class="mb-3">
            <label>Name</label>
            <input class="form-control" name="listing_name" v-model="listing_detail.name">
        </div>
        <card-box>
            <div class="clearfix mb-3">
                <button @click="selectAction" class="btn btn-outline-secondary float-right">Select</button>
                <card-title>Products ({{select_product.length}})</card-title>
            </div>
            <div class="row">
                <table class="table table-hover table-product">
                    <tr v-for="product in select_product" :key="product.sku + product.style" scope="row">
                        <td width="112" class="position-relative"
                            @mouseover="showImgSelected(product, true)"
                            @mouseleave="showImgSelected(product, false)">
                            <img class="thumb-lg" :src="product.thumb" alt="">
                            <image-big
                                    :id="product.id"
                                    :img="product.thumb"
                                    :show="product.showImg"
                            />
                        </td>
                        <td><h5 class="mb-2">{{ product.name }}</h5> <span
                                class="text-muted">SKU: {{ product.sku }}</span></td>
                        <td>
                            {{product.style}}

                        </td>
                        <td>
                            <multiselect placeholder="Template" v-model="product.template"
                                         :options="templateOptionsStyle(product.style)"
                                         track-by="id" label="name"></multiselect>

                        </td>
                        <td class="text-center">
                            <button @click="removeProduct(product)" class="btn btn-outline-danger btn-sm"><i
                                    class="dripicons-trash"></i></button>
                        </td>


                    </tr>
                </table>

                <result-not-found class="border-top d-block" :result="select_product"></result-not-found>
            </div>
        </card-box>

        <button class="btn btn-primary btn-block" @click="save">Save</button>
    </div>


</template>

<script>
    import Multiselect from 'vue-multiselect'
    import CardBox from "./CardBox";
    import CardTitle from "./CardTitle";
    import ResultNotFound from "./ResultNotFound";
    import ImageBig from "./ImageBig";


    export default {
        name: "AmazonListing",
        components: {ImageBig, ResultNotFound, Multiselect, CardTitle, CardBox},
        data: function () {
            return {

                action: '',
                product_template: null,
                product_style: null,
                select_product: [],
                offset: 0,
                limit: 10,
                page: 1,
                last_keyword: '',
                keyword: '',
                products: {},
                product_type: 'T Shirt',
                style: 'Guys Tee',
                design: {},
                export_status: false,
                listing: [],
                listing_detail: {},
                templates: []

            }
        },
        mounted() {
            this.loadDesign()
            this.fetch()
            this.fetchTemplate()
        },

        computed: {
            styleAllow: function () {
                for (let i = 0; i < this.design.styles.length; i++) {

                }
                return []
            },
            templateOptions: function () {
                let tmp = []
                for (let i = 0; i < this.templates.length; i++) {
                    if (this.templates[i].style == this.product_style) {
                        tmp.push({
                            id: this.templates[i].id,
                            name: this.templates[i].name + ' - ' + this.templates[i].style
                        })
                    }

                }
                return tmp
            }
        },

        methods: {
            templateOptionsStyle: function (style) {
                let tmp = []
                for (let i = 0; i < this.templates.length; i++) {
                    if (style == null) {
                        if (this.templates[i].style == this.product_style) {
                            tmp.push({
                                id: this.templates[i].id,
                                name: this.templates[i].name + ' - ' + this.templates[i].style
                            })
                        }
                    } else {
                        if (this.templates[i].style == style) {
                            tmp.push({
                                id: this.templates[i].id,
                                name: this.templates[i].name + ' - ' + this.templates[i].style
                            })
                        }
                    }
                }
                return tmp
            },
            showImg: function (product, status) {
                let idx = this.$_.findKey(this.products, {id: product.id})
                if (idx) {
                    this.$set(this.products[idx], 'showImg', status)
                }
            },
            showImgSelected: function (product, status) {
                let idx = this.$_.findKey(this.select_product, {sku: product.sku})
                if (idx) {
                    this.$set(this.select_product[idx], 'showImg', status)
                }
            },
            selectAction: function () {
                this.$refs.modalSelect.show()
            },
            getStyle: function (styles) {
                if (!styles) return []
                let tmp = []
                for (let i = 0; i < styles.length; i++) {
                    tmp.push(styles[i].name)
                }
                return tmp
            },

            nextPage: function () {
                console.log('next')
                this.page = this.page + 1;
                this.fetch()
            },
            prevPage: function () {
                console.log('back')
                this.page = this.page - 1;
                this.fetch()
            },

            removeProduct: function (item) {
                let idx = this.select_product.indexOf(item)
                this.select_product.splice(idx, 1);
                /*    this.select_product =  this.$_.remove(this.select_product, {
                        sku:item.sku
                    });*/
                let toast = this.$toasted.show("Remove successfully", {
                    theme: "toasted-primary",
                    position: "bottom-center",
                    duration: 1000
                });
            },
            selectProduct: function (item) {

                if (this.product_template == null || this.product_template == '') {
                    this.$swal('Please select template')
                    return false
                }
                if (this.product_style == null || this.product_style == '') {
                    this.$swal('Please select Style')
                    return false
                }
                item.template = this.product_template
                item.type = this.product_style

                for (let i = 0; i < item.style.length; i++) {
                    if (item.style[i].name == this.product_style)
                        item['thumb'] = item.style[i]['thumb']
                }

                let product = {}

                product.sku = item.sku
                product.name = item.name
                product.style = this.product_style
                product.template = this.product_template
                product.thumb = item['thumb']

                let idx = this.$_.findKey(this.select_product, {sku: item.sku, style: this.product_style})
                if (!idx) {
                    this.select_product.push(product)
                    let toast = this.$toasted.show("Select successfully", {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 1000
                    });
                } else {
                    // this.$swal('Product already exists')
                    let toast = this.$toasted.show("Product already exists", {
                        theme: "toasted-primary",
                        position: "bottom-center",
                        duration: 1000
                    });
                }
            },
            fetch: function () {
                let vm = this

                let query = '?style=1';

                if (this.keyword != this.last_keyword) {
                    this.last_keyword = this.keyword
                    this.page = 1;
                    console.log('change keyword')
                }

                if (this.keyword != '') {
                    query += '&keyword=' + encodeURIComponent(this.keyword)
                }


                let offset = (this.page - 1) * this.limit
                query += '&limit=' + this.limit
                query += '&offset=' + offset

                this.$http.get(this.$config.api + 'campaigns' + query).then(function (res) {
                    vm.products = res.data.results
                })
            },

            save: function () {
                let vm = this
                let post = {}
                post.id = this.listing_detail.id
                post.name = this.listing_detail.name
                post.list_product = this.select_product
                this.$http.put(this.$config.api + 'marketing/amazon', post).then(function (res) {
                    vm.$swal('Update successfully')
                    vm.$emit('update', {})
                });
            },
            loadDesign: function () {
                let vm = this
                this.$http.get(this.$config.api + 'design').then(function (res) {
                    vm.design = res.data

                });
            },
            getListing: function (id) {
                let vm = this
                this.$http.get(this.$config.api + 'marketing/amazon/' + id).then(function (res) {
                    vm.listing_detail = res.data
                    if (vm.listing_detail.list_product != null) {
                        vm.select_product = JSON.parse(vm.listing_detail.list_product)
                    } else {
                        vm.select_product = []
                    }

                });
            },
            fetchTemplate: function () {
                let vm = this
                this.$http.get(this.$config.api + 'marketing/amazon/template').then(function (res) {
                    vm.templates = res.data
                });
            }
        }


    }
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>

<style scoped>
    .pointer {
        cursor: pointer;
    }
</style>